import _ from "lodash";
import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import { Row, Col, FormGroup, Radio } from "react-bootstrap";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import MenuList from "./menulist";
import HeaderControl from "./headercontrol";
import HeaderlinksContent from "./headerlinkscontent";
import FooterMenuList from "./footermenulist";
import { fetchHeaderFooter } from "../../actions";

class Menu extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchHeaderFooter(this.props.session);
  }

  render() {
    var { session } = this.props;
    let { deviceSize } = this.props;

    return (
      <Row
        className="scrollable-content panel-body"
        style={{ height: deviceSize.height - 75 }}
      >
        <div className="row">
          <div className="website-header">
            {LocaleStrings.menu_website_first_heading}
          </div>

          <div className="website-menu-header-preview">
            <div className="yogavana-title pull-left">
              {/* <img  className="yogavana-logo" src="../../style/images/header-icons/logo.png" /> */}
              {/* <img  className="yogavana-logo" src="../../style/images/header-icons/logo(3).svg" /> */}
              <div className="menuheader">Header</div>
            </div>
            <div className=" pull-right">
              <MenuList />
            </div>
          </div>
        </div>

        {/* <div className="website-header">
                {LocaleStrings.menu_website_heading_controls}
                 </div>
                 <div className="col-sm-11 website-menu-header-controls">
                    <HeaderControl/>
                 </div> */}

        {/* <div className="row">
                 <div className="website-header">
                {LocaleStrings.menu_website_heading_links}
                 </div>
                 <div className=" website-menu-header-links">
                    <HeaderlinksContent/>
                    
                 </div>
                 </div> */}

        <div
          className="website-header"
          style={{ paddingBottom: 15, paddingLeft: 28 }}
        >
          {LocaleStrings.menu_website_footer_preview}
        </div>

        <div className="website-menu-footer-preview">
          <div
            className="row"
            style={{
              borderBottom: "1px solid #9ca4b4",
              marginLeft: 0,
              marginRight: 0,
            }}
          >
            <div
              className="pull-left"
              style={{ paddingTop: 65, color: "white" }}
            >
              {/* <img  className="yogavana-logo" src="../../style/images/header-icons/whitelogo.png" style={{marginLeft:-40}} /> */}
              <div className="menufooter">Footer</div>
            </div>
            <div className="pull-right">
              <FooterMenuList />
            </div>
          </div>
          {/* <div className="copyright-yogavana">
                 Copyright &#xa9; 2021 Yogavana. All Right Reserved.
                 </div> */}
        </div>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    headerFooter: state.headerFooter,
  };
}

export default connect(mapStateToProps, { fetchHeaderFooter })(Menu);
